import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import SectionContainer from '../SectionContainer';
import Field, { hasDataInFields } from '../../Field';
import { AspectRatioWrapper } from '../../../../components';

import css from './SectionWhoAreWeLookingFor.module.css';
import img from './images/tutor.png';

const SectionWhoAreWeLookingFor = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
    intl,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const aspectWidth = 1;
  const aspectHeight = 1;
  return (
    <SectionContainer
      id={sectionId}
      className={classNames(className)}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.container}>
        <div className={css.left}>
          {hasHeaderFields ? (
            <header className={classNames(css.header, defaultClasses.sectionDetails)}>
              <Field data={title} className={defaultClasses.title} options={fieldOptions} />
              <Field
                data={description}
                className={defaultClasses.description}
                options={fieldOptions}
              />
            </header>
          ) : null}

          <div className={css.blocksWrapper}>
            <div className={css.block}>
              <ul className={css.whoWeAreLookingFor}>
                <li>{intl.formatMessage({ id: 'LandingPage.SectionWhoAreWeLookingFor.1' })}</li>
                <li>{intl.formatMessage({ id: 'LandingPage.SectionWhoAreWeLookingFor.2' })}</li>
                <li>{intl.formatMessage({ id: 'LandingPage.SectionWhoAreWeLookingFor.3' })}</li>
                <li>{intl.formatMessage({ id: 'LandingPage.SectionWhoAreWeLookingFor.4' })}</li>
                <li>{intl.formatMessage({ id: 'LandingPage.SectionWhoAreWeLookingFor.5' })}</li>
              </ul>
            </div>
          </div>
          <Field
            data={callToAction}
            className={classNames(css.cta, defaultClasses.ctaButton)}
            options={fieldOptions}
          />
        </div>
        <div className={css.right}>
          <AspectRatioWrapper
            className={css.aspectRatioWrapper}
            width={aspectWidth}
            height={aspectHeight}
          >
            <img className={css.rootForImage} alt={'tutor'} src={img} />
          </AspectRatioWrapper>
        </div>
      </div>
    </SectionContainer>
  );
};

SectionWhoAreWeLookingFor.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionWhoAreWeLookingFor.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
};

export default SectionWhoAreWeLookingFor;
